'use strict';

import animationsUtility from '../utility/animations.js'

const init = () => {
    const blogArticlesList = document.querySelector('.tc-website-blogarticleslist')

    if (blogArticlesList) {
        const moreBlogArticlesButton = blogArticlesList.querySelector('.more-blog-articles-button')

        // load more blog articles
        moreBlogArticlesButton.addEventListener('click', async () => {
            const wrapper = blogArticlesList.querySelector('.blog-articles-list-wrapper')
            const initialHeight = wrapper.offsetHeight

            // fetch data
            fetchDataFromUrl(moreBlogArticlesButton.dataset.moreArticlesUri, moreBlogArticlesButton.dataset.moreIndex)
                .then((data) => {
                    const parser = new DOMParser()
                    const doc = parser.parseFromString(data.blogArticles, 'text/html')
                    const elements = doc.body.children

                    // append new blog articles
                    Array.from(elements).forEach((element) => {
                        wrapper.append(element)
                    })

                    // animate new blog articles
                    const blogArticleItem = wrapper.querySelector('.tc-website-blogarticleslistitem')
                    const computedStyle = window.getComputedStyle(blogArticleItem)
                    const marginTop = parseFloat(computedStyle.marginTop)
                    const marginBottom = parseFloat(computedStyle.marginBottom)
                    const blogArticleItemHeight = blogArticleItem.offsetHeight + marginTop + marginBottom
                    const hiddenBlogArticles = wrapper.querySelectorAll('.tc-website-blogarticleslistitem.hidden')
                    const newHeight = initialHeight + (blogArticleItemHeight * Math.ceil(hiddenBlogArticles.length / 2))

                    animationsUtility.animateBlogArticlesListContainerHeight(wrapper, initialHeight, newHeight)
                    animationsUtility.animateBlogArticlesList(hiddenBlogArticles)

                    // check if load more button should be hidden or not
                    if (data.showLoadMoreButton) {
                        moreBlogArticlesButton.dataset.moreIndex = data.index
                    } else {
                        moreBlogArticlesButton.classList.add('hidden')
                    }

                    // TODO: update LD+JSON data
                })
        })
    }
}

const fetchDataFromUrl = async (url, index) => {
    const data = {
        blogArticlesList: true,
        index: index
    }

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    }).then((response) => {
        return response.json()
    }).then((data) => {
        return data
    }).catch((error) => {
        console.error(error)
    })
}

export default {init}
